import { initialState } from "./state"

export default {
  updateOpenDrawer: (state, payload) => {
    state.openDrawer = payload
  },
  updateShowNavbar: (state, payload) => {
    state.showNavbar = payload
  },
  updateTopBanner: (state, payload) => {
    state.topBanner = payload
  },
  updateLoadingScreen: (state, payload) => {
    state.loadingScreen = payload
  },
  updateAnnouncement: (state, payload) => {
    state.announcement = payload
  },
  resetInterface: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
